import React from 'react';
import { FormattedHTMLMessage, injectIntl } from 'react-intl';
import { FormFieldComponentProps, ExtendedErrorId, ErrorId } from '@sheerid/jslib';
import { InputTextComponent } from '../FormInputs/InputText';

interface PassedProps {
    errorId: ErrorId | ExtendedErrorId;
    onKeyDown?: Function;
}

export const ConfirmEmail = ({
    value,
    onChange,
    intl,
    errorId,
    isErrored = false,
    onKeyDown = undefined,
    placeholder = '',
}: FormFieldComponentProps & PassedProps) => (
    <div className="sid-field sid-email">
        <div className="sid-l-space-top-md" />
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label htmlFor="sid-confirm-email">
            <div className={`sid-field__label-with-explanation ${placeholder ? 'sid-h-screen-reader-only' : ''}`}>
                <div className="sid-field__label sid-field__label--required">
                    <FormattedHTMLMessage
                        id="confirmEmailAddress"
                        defaultMessage="Email address"
                    />
                </div>
            </div>
        </label>

        <InputTextComponent
            id="confirm-email"
            isErrored={isErrored}
            onChange={(event: any) => onChange(event.target.value)}
            onKeyDown={typeof onKeyDown === 'function' ? (e: any) => onKeyDown(e) : undefined}
            placeholder={placeholder || intl.formatMessage({ id: 'emailAddressPlaceholder', defaultMessage: 'Email*' })}
            type="email"
            value={value}
            required
        />

        {
            isErrored ? (
                <div className="sid-field-error">
                    <FormattedHTMLMessage
                        id={`errorId.${errorId}`}
                        defaultMessage="Invalid confirm email"
                    />
                </div>
            ) : null
        }
    </div>
);

export const ConfirmEmailComponent = injectIntl(ConfirmEmail);
